import {format, isToday, isYesterday, isSameWeek} from 'date-fns'
import {it} from 'date-fns/locale'

/**
 * Format a date for notification display, following these rules:
 * - Today: "oggi alle HH:mm"
 * - Yesterday: "ieri alle HH:mm"
 * - Same week: "giorno alle HH:mm" (e.g., "lunedì alle 15:30")
 * - Beyond a week: "DD/MM/YYYY HH:mm"
 */
export const formatNotificationDate = (date: Date): string => {
    const now = new Date()

    // If the date is today
    if (isToday(date)) {
        return `oggi alle ${format(date, 'HH:mm')}`
    }

    // If the date is yesterday
    if (isYesterday(date)) {
        return `ieri alle ${format(date, 'HH:mm')}`
    }

    // If the date is in the same week
    if (isSameWeek(date, now)) {
        // Format day name in Italian (e.g., "lunedì")
        const dayName = format(date, 'EEEE', {locale: it})
        return `${dayName} alle ${format(date, 'HH:mm')}`
    }

    // If the date is beyond the current week
    return format(date, 'dd/MM/yyyy HH:mm')
}
